import { View, XStack } from 'tamagui';

import { Icon, type IconType } from '../icons/Icon';
import { BodyMediumRegular } from '../text/Typography';

export interface BulletPointProps {
    icon: IconType;
    text: string;
}

export const BulletPoint = ({ icon, text }: BulletPointProps) => {
    return (
        <XStack gap={10} marginVertical={10}>
            <View paddingTop={3}>
                <Icon icon={icon} size={18} color="$gray1200" />
            </View>

            <BodyMediumRegular flex={1}>{text}</BodyMediumRegular>
        </XStack>
    );
};
